var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-6"},[(!_vm.landingParams.dealerId && !_vm.landingParams.publicId)?[_c('h1',[_vm._v("Wrong url!!! Return to the dealers site!")])]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }